import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-other-services-page',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './app-other-services-page.component.html',
  styleUrls: ['./app-other-services-page.component.scss']
})
export class OtherServicesPageComponent {
  readonly services = [
    { tag: 'Recovery', name: 'Priority institution update pack', description: 'Send urgent change notifications to verified institutions after a number or address change.' },
    { tag: 'Backup', name: 'Enhanced contact vault', description: 'Expand backup coverage for contacts, SMS archives, and future device recovery support.' },
    { tag: 'Identity', name: 'Profile verification assist', description: 'Accelerate verification for institutions that require proof of recent detail changes.' }
  ];
}

@Component({
  selector: 'app-orders-page',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './app-orders-page.component.html',
  styleUrls: ['./app-orders-page.component.scss']
})
export class OrdersPageComponent {
  readonly orders = [
    { name: 'Priority institution update pack', description: '12 linked institution updates queued with audit trail.', status: 'Ready for payment' },
    { name: 'Enhanced contact vault', description: 'Daily device contact backup with expanded retention.', status: 'Draft' }
  ];
}

@Component({
  selector: 'app-checkout-page',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './app-checkout-page.component.html',
  styleUrls: ['./app-checkout-page.component.scss']
})
export class CheckoutPageComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly checkoutForm = this.formBuilder.group({
    orderSummary: ['Priority institution update pack, Enhanced contact vault', Validators.required],
    billingEmail: ['jane@example.com', [Validators.required, Validators.email]],
    paymentMethod: ['saved-card', Validators.required]
  });
}